import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withAreaGetter } from 'providers/AreasConsumers';
import { areas } from 'constants/areas';
import { ADMIN_COMMISSIONS_READ, ADMIN_COMMISSIONS_WRITE } from 'constants/rightsCodes';
import { defaultLeasingCommission, leasingCommissionModalVar } from 'features/leasingCommission/variables';
import LeasingCommissionListBrowser from './LeasingCommissionListBrowser';
import Portal from 'utils/portal/Portal';
import HeaderLinks from './header/HeaderLinks';
import HeaderTitle from './header/HeaderTitle';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = ({ getElemByAreaKey }) => {
  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <HeaderTitle />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_COMMISSIONS_WRITE} withForbiddenPage={false}>
          <HeaderLinks onAdd={() => leasingCommissionModalVar({ open: true, item: defaultLeasingCommission })} />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_COMMISSIONS_READ}>
        <LeasingCommissionListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
